import { FileType } from "./file-type";

export class SchoolFile {

    constructor(
        public id: number,
        public name: string,
        public schoolId: number,
        public comment: string,
        public fileType: FileType | null,
        public needsToBeCompleted: boolean
    ){}
}
